<template>
  <div class="home">
    <div class="home__hero-img">
      <div class="home__hero-img__big-heading">
        <h1>Zdrowy, naturalny smak naszych potraw  <br />
            czyni naszą restaurację jedną <br />
            z <span class="main">Najlepszych</span> na rynku.</h1>
      </div>
      <div class="home__hero-img__links">
        <a href="https://www.facebook.com/JadalniawMiedzylesiu/" target="_blank" class="to-facebook">Odwiedź nas na facebook'u</a>
        <a href="#contact" class="to-contact">Skontaktuj się z nami</a>
      </div>
    </div>
    <AboutUs />
    <shortInfo />
    <Gallery />
    <Contact />
  </div>
</template>

<script>
import { AboutUs, shortInfo, Gallery, Contact } from '../components/home_components'

export default {
  name: 'home',
  components: { AboutUs, shortInfo, Gallery, Contact },
  data () {
    return {
      nav_scrolled: false
    }
  },
  created() {
    window.addEventListener('scroll', () => {
      let scroll_pos = window.scrollY,
        hero_img = document.querySelector('.home__hero-img');
      hero_img.style.backgroundPositionY = `${scroll_pos / 3}px`;
    })
  }
}
</script>
